import { apiClient } from '@/services/api/client';
import type { SectionDescription } from '@/types/sectionDescription';

export function getSectionDescriptions(
  productId: number,
  language: string
): Promise<SectionDescription[]> {
  return apiClient.get<SectionDescription[]>(
    `/api/products/${productId}/section-descriptions?language=${language}`
  );
}
